<template>
  <section class="editable-area">
    <InputRichText v-model="data" />
    <div
      ref="editableContent"
      style="display: none"
      :class="className"
      contenteditable="true"
      v-html="data"
    />
    <div class="upload-image">
      <input
        v-if="showUploader"
        id="file-input"
        ref="uploadInput"
        type="file"
        accept="application/pdf"
        class="button is-outlined file-uploader"
        @change="uploadPdf"
      >
      <button
        v-else
        class="button is-white change-image"
        @click="handleChangePdf()"
      >
        Change
        pdf
      </button>
      <a
        v-if="!showUploader"
        class="button primary-light"
        :href="pdfFile"
      >Download pdf</a>
    </div>
    <div class="actions">
      <button
        type="button"
        class="button primary"
        @click="handleTemplateSave"
      >
        Save
      </button>
    </div>
  </section>
</template>
<script>
import InputRichText from '../Inputs/InputRichText';
import { isValidSize } from '@/utils/validationUtils';
import store from '../../store';

export default {
  name: 'EditableArea',
  components: {
    InputRichText
  },
  props: {
    className: String,
    content: String,
    handleSave: Function,
    pdfFile: String
  },
  data() {
    return {
      showUploader: !this.pdfFile,
      data: this.content,
      file: '',
      store
    };
  },
  methods: {
    handleTemplateSave() {
      const { editableContent } = this.$refs;
      if (typeof this.handleSave === 'function' && editableContent && editableContent.innerHTML) {
        this.handleSave(editableContent.innerHTML, this.file);
      }
    },
    handleChangePdf() {
      this.showUploader = true;
    },
    uploadPdf(event) {
      const file = event.target.files[0];
      if (!isValidSize(file.size, 10)) {
        this.$root.$emit('showToast', {
          message: 'File size is too big. Please choose the smaller file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInput.value = '';
        this.file = '';
        this.showUploader = false;
        return;
      }
      this.file = file;
    }
  }
};
</script>
<style scoped lang="scss">
    .editable-area {
      padding: 10px;
        .actions {
            display: flex;
            justify-content: flex-end;
            top:50px;

            .button {
                margin: 0 5px 5px;
            }
        }
    }
    .upload-image {
      margin-bottom: 10px;
    }
</style>
